import React from "react";
import "./BookingHeader.scss";
import { BsChevronLeft } from "react-icons/bs";
import { CgClose } from "react-icons/cg";
import { useSelector } from "react-redux";
import { locale } from "../../translate/sweden";

const BookingHeader = (props) => {
  const widgetInfo = useSelector((state) => state.widget.widget);

  return (
    <div
      className={
        "BookingHeader" +
        (props.termsOpen || props.notesOpen ? " terms" : "") +
        (props.reviews ? " reviews" : "") +
        (props.steps === 5 && props.step === 1
          ? " anime"
          : props.step === 2
          ? " anime"
          : "")
      }
      style={{
        backgroundImage: `${
          widgetInfo.company.widget_settings.background_color
            ? widgetInfo.company.widget_settings.background_color
            : "linear-gradient(117.58deg, #1A73E8 0%, #1A56A6 100%)"
        }`,
      }}
    >
      <div className="stepInfo">
        <div className="left">
          <div className="back" onClick={props.onBack}>
            <BsChevronLeft />
          </div>
          <p>
            {locale.step} {props.steps === 5 ? props.step : props.step - 1}{" "}
            {locale.of} {props.steps}
          </p>
        </div>
        {props.step === 1 && <h4>{locale.choosePlace.heading}</h4>}
        {props.step === 2 && <h4>{locale.chooseService.heading}</h4>}
        {props.step === 3 && <h4>{locale.chooseWorker.heading}</h4>}
        {props.step === 4 && <h4>{locale.chooseTime.heading}</h4>}
        {props.step === 5 &&
          !props.notesOpen &&
          (props.termsOpen ? (
            <h4>{locale.terms}</h4>
          ) : (
            <h4>{locale.lastBookingStep.heading}</h4>
          ))}
        {props.notesOpen && <h4>{locale.lastBookingStep.addBookingNotes}</h4>}
        {props.reviews && <h4>{locale.recensions.heading}</h4>}
        <div className="close" onClick={props.onClose}>
          <CgClose />
        </div>
      </div>
      {props.step === 1 && <h2>{locale.choosePlace.heading}</h2>}
      {props.step === 2 && <h2>{locale.chooseService.heading}</h2>}
      {props.step === 3 && <h2>{locale.chooseWorker.heading}</h2>}
      {props.step === 4 && <h2>{locale.chooseTime.heading}</h2>}
      {props.step === 5 &&
        !props.notesOpen &&
        (props.termsOpen ? (
          <h2>{locale.terms}</h2>
        ) : (
          <h2>{locale.lastBookingStep.heading}</h2>
        ))}
    </div>
  );
};

export default BookingHeader;
